import { h, render } from 'preact'

import App from './containers/App'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const container = document.getElementById('js-products-app')

if (container) {
  const model = container.dataset.model
  const appointment = container.dataset.appointment
  const invoice = container.dataset.invoice
  const slider = container.dataset.slider
  const filterTitle = container.dataset.filtertitle
  const defaultOption = container.dataset.defaultoption

  if (model === undefined) {
    throw Error(`Products app: dataset-model is undefined.`)
  }
  if (appointment === undefined) {
    throw Error(`Products app: dataset-appointment is undefined.`)
  }
  if (invoice === undefined) {
    throw Error(`Products app: dataset-invoice is undefined.`)
  }
  if (slider === undefined) {
    throw Error(`Products app: dataset-slider is undefined.`)
  }

  if (filterTitle === undefined) {
    throw Error('Products app: dataset-filtertitle is undefined.')
  }

  if (defaultOption === undefined) {
    throw Error('Products app: dataset-defaultoption is undefined.')
  }

  render(
    <App
      title={filterTitle}
      model={model}
      appointment={appointment}
      invoice={invoice}
      sliderVisiblity={slider}
      defaultOption={defaultOption}
    />,
    container
  )
}



// WEBPACK FOOTER //
// ./src/js/products/index.js